import { useEffect, useState } from "react";
import { HeartHandshake } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const DonationThanks = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("donation") !== "thanks") return;
    setOpen(true);
    params.delete("donation");
    const qs = params.toString();
    window.history.replaceState(null, "", `${window.location.pathname}${qs ? `?${qs}` : ""}${window.location.hash}`);
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-md border-emerald-800 bg-neutral-950" data-testid="donation-thanks-dialog">
        <div className="kente kente-thin -mx-6 -mt-6 mb-2 rounded-t-lg" />
        <HeartHandshake className="h-10 w-10 text-emerald-400" strokeWidth={1.5} />
        <DialogTitle className="font-display text-2xl text-gold">Thank you — your payment is being confirmed</DialogTitle>
        <DialogDescription className="text-sm leading-relaxed text-neutral-300">
          Ẹ ṣé for supporting the Egúngún Festival. Stripe will confirm your payment with the festival team shortly — there's nothing more you need to do.
        </DialogDescription>
        <button onClick={() => setOpen(false)} className="mt-2 h-12 rounded-full bg-amber-500 font-display text-lg font-semibold text-neutral-950 hover:bg-amber-400" data-testid="donation-thanks-close">
          Back to the festival
        </button>
      </DialogContent>
    </Dialog>
  );
};
